import {
	DEFAULT_CLIENT_FEED_CATEGORY_ORDER,
	normalizeClientFeedCategoryOrder,
} from '@/entities/client-feed-categories';

export interface RepairStoredOrderResult {
	order: ReturnType<typeof normalizeClientFeedCategoryOrder>;
	needsWrite: boolean;
}

export function repairStoredOrder(raw: string | null): RepairStoredOrderResult {
	if (!raw) {
		return { order: [...DEFAULT_CLIENT_FEED_CATEGORY_ORDER], needsWrite: false };
	}

	try {
		const parsed: unknown = JSON.parse(raw);
		const normalized = normalizeClientFeedCategoryOrder(parsed);
		const needsWrite = !Array.isArray(parsed) || JSON.stringify(normalized) !== JSON.stringify(parsed);
		return { order: normalized, needsWrite };
	} catch {
		return { order: [...DEFAULT_CLIENT_FEED_CATEGORY_ORDER], needsWrite: true };
	}
}
